import type { AgentIds as CustomTraceAgentIds } from "@/types_api/backend/transport/custom_trace_metric_preview_request"

export const MAX_TRACE_AGENT_SCOPE_IDS = 20

export function toTraceAgentIds(
  agentIds: string[],
): CustomTraceAgentIds | undefined {
  if (agentIds.length === 0 || agentIds.length > MAX_TRACE_AGENT_SCOPE_IDS) {
    return undefined
  }

  return agentIds as CustomTraceAgentIds
}
